// C:\Users\server\Desktop\FRONTEND\app-user-front\src\Footer.js
import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const handleCategoryClick = (category, e) => {
    e.preventDefault(); // normal anchor reload ko roke
    navigate(`/products?category=${encodeURIComponent(category)}`);
    window.scrollTo(0, 0);
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.footerContainer}>
        <div style={styles.footerContent}>
          
          {/* Logo + Text */}
          <div style={styles.footerSection}>
            <img
              src="https://swapiify.com/wp-content/uploads/2025/02/swapiify-1-1.png"
              alt="Swapiify"
              style={styles.footerLogo}
            />
            <p style={styles.footerText}>
              Swap smarter, live sustainably. Turn what you have into what you need
              with effortless exchanges and a thriving community.
            </p>
          </div>

          {/* Categories */}
          <div style={styles.footerSection}>
            <h4 style={styles.footerHeading}>Categories</h4>
            <div style={styles.footerLinks}>
              {["Sporting Goods", "Toys & Games","Accessories", "Books", "Clothes","Shoes",  "Bags"].map(
                (category, index) => (
                  <a
                    key={index}
                    href={`/products?category=${encodeURIComponent(category)}`}
                    onClick={(e) => handleCategoryClick(category, e)}
                    style={styles.footerLink}
                  >
                    {category}
                  </a>
                )
              )}
            </div>
          </div>

          {/* Info */}
          <div style={styles.footerSection}>
            <h4 style={styles.footerHeading}>Information</h4>
            <div style={styles.footerLinks}>
              <a href="/about" style={styles.footerLink}>About Us</a>
              <a href="/contact" style={styles.footerLink}>Contact Us</a>
              <a href="#" style={styles.footerLink}>Terms & Conditions</a>
              <a href="/privacy-policy" style={styles.footerLink}>Privacy Policy</a>
              <a href="/acceptable-use-policy" style={styles.footerLink}>Acceptable Use Policy</a>
            </div>
          </div>

          {/* Contact */}
          <div style={styles.footerSection}>
            <h4 style={styles.footerHeading}>Contact Us</h4>
            <p style={styles.footerText}>
              Contact us at: info@swapiify.com
            </p>

            {/* Social Icons */}
            <div style={styles.socialIcons}>
              <a href="#" style={styles.socialIcon}><FaFacebookF /></a>
              <a href="#" style={styles.socialIcon}><FaInstagram /></a>
              <a href="#" style={styles.socialIcon}><FaTwitter /></a>
              <a href="#" style={styles.socialIcon}><FaLinkedinIn /></a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div style={styles.footerBottom}>
          <p style={styles.copyright}>
            Copyright © 2025 Swapiify
          </p>
        </div>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: "#f7f7f7ff",
    color: "#fff",
    padding: "60px 0 20px",
  },
  footerContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  },
  footerContent: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
    gap: "40px",
    marginBottom: "40px",
  },
  footerSection: {},
  footerLogo: {
    height: "35px",
    width: "auto",
    marginBottom: "20px",
  },
  footerHeading: {
    fontSize: "1.2rem",
    marginBottom: "20px",
    color: "#000000ff",
    fontWeight: "bold",
  },
  footerText: {
    color: "#000000ff",
    lineHeight: 1.6,
    margin: 0,
  },
  footerLinks: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  footerLink: {
    color: "#000000ff",
    textDecoration: "none",
    transition: "color 0.3s ease",
  },

  socialIcons: {
    display: "flex",
    gap: "14px",
    marginTop: "15px",
  },
  socialIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "#702963",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    textDecoration: "none",
    transition: "transform 0.3s ease, background 0.3s ease",
  },

  footerBottom: {
    borderTop: "1px solid #ddd",
    paddingTop: "20px",
    textAlign: "center",
  },
  copyright: {
    color: "#000000ff",
    fontSize: "14px",
    margin: 0,
  },
};
